module.exports = __webpack_public_path__ + "media/img/illustrations/male-9e6d8329c32e3d19ad9be6ee47308fc6.svg";